import { map } from 'lodash';
import { setNotificationTemplates } from './actions';

import NotificationTemplatesService from './NotificationTemplatesService';

const NOTIFICATION_TYPES = {
  LOCATION: 0,
  RECURRING: 1,
};

const toNotificationTemplateRequest = values => ({
  frequency: values.frequency,
  frequencyUnit: values.frequencyUnit,
  id: values.id,
  idleTime: values.idleTime,
  isActive: values.isActive,
  locationTypeId: values.locationTypeId,
  text: values.text,
  timeOfDay: !!values.timeOfDay ? values.timeOfDay : null,
  typeId: NOTIFICATION_TYPES.LOCATION,
});

const toRequest = notificationTemplates => ({
  notificationTemplates: map(notificationTemplates, template =>
    toNotificationTemplateRequest(template),
  ),
});

export const saveNotificationTemplatesAsync = notificationTemplates => dispatch => {
  return dispatch(
    NotificationTemplatesService.create(toRequest(notificationTemplates)),
  ).then(() => dispatch(setNotificationTemplates(notificationTemplates)));
};

export const fetchNotificationTemplatesAsync = () => dispatch => {
  return dispatch(NotificationTemplatesService.get()).then(
    notificationTemplates => {
      return dispatch(setNotificationTemplates(notificationTemplates));
    },
  );
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/notificationTemplates/thunks.js